






















































































































































































































































































































































import { Dictionary } from "lodash";
import moment from "moment";
import { Component, Prop, Vue, Ref } from "vue-property-decorator";
import {
  GetTreamentGraphResponse,
  TreatmentGraphModel,
  TreatmentMonitoringApi,
  TreatmentRequestModel,
  UnitsApi,
  VariableChartDataModel,
  VariableModel,
  VariablesApi,
} from "../../../apis";
import DataLog from "./DataLog.vue";
import ProcessTime from "./ProcessTime.vue";
import StatusParam from "./StatusParam.vue";
import Params from "./Param.vue";
import Calibration from "./Calibration.vue";
import { deepCopy } from "deep-copy-ts";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { AxiosResponse } from "axios";
import JSCharting from 'jscharting-vue';
@Component({
  components: {
    DataLog,
    ProcessTime,
    StatusParam,
    Calibration,
    Params,
    ValidationObserver,
    ValidationProvider,
    JSCharting,
  },
})
export default class TreatmentGraphV4 extends Vue {
  @Ref("observer") readonly observer!: InstanceType<typeof ValidationObserver>;
  @Prop({ default: true }) searchDisplay: boolean;
  @Prop({ default: "" }) unitId: string;
  @Prop({ default: "" }) selectedTimeZone: string;
  @Prop({ default: false }) graph: boolean;
  @Prop({ default: "" }) startDate: string;
  @Prop({ default: "" }) endDate: string;
  @Prop({ default: "" }) treatmentId: string;
  @Prop({ default: [] }) treatments: TreatmentRequestModel[];

  variables: VariableModel[] = [];
  applyTimezone = true;
  chartLoading = false;
  chartBoolLoading = false;
  maxYaxis = 100.0;
  minYaxis = 0.0;
  isShowSearch = true;
  isShowSelectParameter = true;

  //   option chart 1
  seriesBool: { [k:string]: any } = {};
  series = [];
  maxValue = 0;
  seriesRemoved = [];

  tickLabelText(v: number) {
    return moment.unix(v / 1000).format("HH:mm DD/MM");
  }

  formatLabel(v: number) {
    return v.toFixed(2);
  }

  formatTooltip(data: any) {
    const date = moment.unix(data.x / 1000).format("HH:mm DD/MM");
    return `<b>${date}</b><hr><b>${data.series.name}: ${data.y}</b>`;
  }
  xAxis_scale_range = [];
  chartOptions = {
    type: "line",
    axisToZoom: 'xy',
    series: [],
    legend_visible: false,
    defaultPoint: {
      label_visible: false,
      tooltip: this.formatTooltip,
      marker: {
        visible: false,
      }
    },
    yAxis: {
      scale: {
        range: [0, 100],
      },
      line: {
        width: 1,
        color: 'rgba(50,49,48,0.73)',
        caps: {
          start: { type: 'circle' }
        }
      },
      crosshair: {
        enabled:true,
        snapToData:false,
      },
      defaultTick_label_text: this.formatLabel
    },
    xAxis: {
      scale: {
        range: [],
      },
      overflow:'hidden',
      crosshair: {
        enabled:true,
        snapToData:false,
      },
      defaultMinorTick: {
        label_style_fontWeight: 'normal',
        gridLine_color: ['rgba(50,49,48,0.73)', 0.2],
        gridLine_dashStyle: 'Solid'
      },
      defaultTick: {
        label_style_fontWeight: 'bold',
        gridLine_color: ['rgba(50,49,48,0.73)', 0.2],
        label_text: this.tickLabelText,
      },
      formatString: 'hh:mm DD/MM',
      line: {
        width: 0.5,
        color: 'rgba(50,49,48,0.73)',
        caps: {
          start: { type: 'circle' }
        }
      },
      scale_type: 'time'
    },
    events_zoomed: this.selectionHandler,
    events_scrolled: this.selectionHandler
  };

  selectionHandler(obj) {
    let min = parseInt(obj[1].min);
    let max = parseInt(obj[1].max);
    if (isNaN(min)) min = 0;
    if (isNaN(max)) max = this.maxValue || 100;
    if ((min === 0 && max === 100) || (this.searchForm.yMin === min && this.searchForm.yMax === max)) {
      this.searchForm.yMin = null;
      this.searchForm.yMax = null;
      this.chartOptions.yAxis.scale.range = [0, this.maxValue || 100];
      this.reactiveWithNumberChart(true);
    } else {
      this.reactiveWithNumberChart(false);
    }
    this.beforeZoomNumberChart(parseInt(obj[0].min), parseInt(obj[0].max));
  }

  getOptionBooleanChart(points, color, name) {
    return {
      type: 'areaStep',
      legend_visible: false,

      yAxis: {
        scale: {
          interval: 1,
          minorInterval: 1,
          range: [0, 8],
        },
        defaultTick: {
          gridLine_visible: false,
          label_text: '',
        },
      },
      xAxis: {
        scale_range: this.xAxis_scale_range? this.xAxis_scale_range: [],
        scale_type: 'time',
        defaultTick: {
          gridLine_visible: false,
          label_text: '',
        },
        line: {
          width: 1,
          color: 'rgba(109,108,106,0.12)',
        },
      },
      defaultPoint: {
        label_visible: false,
        tooltip: this.getLabelBooleanChart,
        marker: {
          visible: false,
        },
      },
      defaultSeries: {
        shape_opacity: 1,
        color: color,
      },
      series: [
        {
          line_width: 0.8,
          points: points, name: name, color: color,
        }
      ],
    };
  }

  getLabelBooleanChart(v) {
    const date = moment.unix(v.x / 1000).format("HH:mm DD/MM");
    const boolParam = this.BOOL_PARAMERTERS.find(param => param.value === v.series.name);
    const name = boolParam ? boolParam.text : v.series.name;
    const value = v.y === 1 ? 'ON' : 'OFF';
    return `${date} ${name}: ${value}</b>`;
  }

  boolChart: Dictionary<VariableChartDataModel[]> = {};
  selectedNumericParam: string[] = [];
  selectedBoolParam: string[] = [];
  selectedUnit: any = null;

  searchForm = {
    dateStart: "",
    dateEnd: "",
    treatmentId: "",
    yMin: null,
    yMax: null,
  };

  get RULES_DATE() {
    if (this.searchForm.treatmentId) {
      return '';
    }
    return 'my-required|my-date';
  }

  get VALID_SEARCH_FORM() {
    if (!this.searchForm.treatmentId && !this.searchForm.dateStart && !this.searchForm.dateEnd) {
      return true;
    }
    return false;
  }
  get TREATMENTS() {
    return !this.treatments
      ? []
      : this.treatments.map((val) => ({
          value: val.id,
          text: val.number,
        }));
  }

  get NUMERIC_PARAMERTERS() {
    return !this.variables
      ? []
      : this.variables
          .filter((val) => ["BYTE", "UBYTE", "FLOATING"].includes(val.type))
          .map((val) => {
            return {
              value: val.id,
              text: val.variableName,
              color: val.color || this.generateRandomColor(),
            };
          });
  }

  get BOOL_PARAMERTERS() {
    return !this.variables
      ? []
      : this.variables
          .filter((val) => ["BOOL"].includes(val.type))
          .map((val) => {
            return {
              value: val.id,
              text: val.variableName,
              color: val.color || this.generateRandomColor(),
            };
          });
  }

  get X_HOUR() {
    return this.$util.getConfig().settings.graph.xHour;
  }

  generateRandomColor() {
    var letters = "0123456789ABCDEF";
    var color = "#";
    for (var i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }

  setYAxisRange(yMin?: number | null, yMax?: number | null) {
    const min = yMin !== null && yMin !== undefined ? Number(yMin) : 0;
    const max = yMax !== null && yMax !== undefined ? Number(yMax) : this.maxValue;
    if (!isNaN(min) && !isNaN(max) && min < max) {
      this.chartOptions.yAxis.scale.range = [min, max];
    } else {
      this.chartOptions.yAxis.scale.range = [0, this.maxValue || 100];
    }
  }

  created() {
    this.searchForm.dateEnd = moment().format("YYYY-MM-DD");
    this.searchForm.dateStart = moment().add(-3, "days").format("YYYY-MM-DD");
    this.calculateXAxisNumberChart();
  }

  async fetchUnitData() {
    const resp = await new UnitsApi().getUnitById({ id: this.unitId });
    this.selectedUnit = resp.data.data;
  }

  async fetchVariablesData() {
    const resp = await new VariablesApi().getVariablesByUnitId({
      id: this.unitId,
    });
    this.variables = resp.data.data.filter((val) => val.graph);
    this.getSelectedNumericParam();
    this.getSelectedBoolParam();
  }

  getSelectedNumericParam() {
    const paramDict =localStorage.getItem("treatmentMonitoringDetailNumber");
    let params;
    if (paramDict){
      try {
        const data = JSON.parse(paramDict);
        params = data[this.unitId];
      } catch (error) {
        
      }
    }
    if (!params || this.lodash.isEmpty(params)) {
      this.selectedNumericParam = this.NUMERIC_PARAMERTERS.map(
        (val) => val.value
      );
    } else {
      this.selectedNumericParam = this.lodash.intersection(
        params,
        this.NUMERIC_PARAMERTERS.map((val) => val.value)
      );
    }
  }

  getSelectedBoolParam() {
    const paramDict =localStorage.getItem("treatmentMonitoringDetailBool");
    let params;
    if (paramDict){
      try {
        const data = JSON.parse(paramDict);
        params = data[this.unitId];
      } catch (error) {
        
      }
    }
    if (!params || this.lodash.isEmpty(params)) {
      this.selectedBoolParam = this.BOOL_PARAMERTERS.map((val) => val.value);
    } else {
      this.selectedBoolParam = this.lodash.intersection(
        params,
        this.BOOL_PARAMERTERS.map((val) => val.value)
      );
    }
  }

  mounted() {
    this.isShowSearch = !this.$screen.isMobile();
    this.isShowSelectParameter = !this.$screen.isMobile();
    this.$nextTick(() => {
      this.chartLoading = true;
      this.$emit("loaded");
      this.doSearch();
    });
  }

  calculateXAxisNumberChart() {
    let timestampRangeSet = new Set<number>();
    const dateStart = moment(this.searchForm.dateStart, "YYYY-MM-DD");
    const dateEnd = moment(this.searchForm.dateEnd, "YYYY-MM-DD");
    while (dateEnd.diff(dateStart, "days") >= 0) {
      timestampRangeSet.add(dateStart.unix());
      timestampRangeSet.add(dateStart.add(12, "hours").unix());
      timestampRangeSet.add(dateStart.add(12, "hours").unix());
    }
  }

  isChartReady(): boolean {
    const numberChartUI = this.$refs[ "numericChart" ] as any;
    return !!(numberChartUI && numberChartUI.instance && typeof numberChartUI.instance.axes === 'function');
  }

  isBooleanChartReady(chartName: string): boolean {
    const boolChartUI = this.$refs[`boolchart-${chartName}`] as any;
    return !!(boolChartUI && boolChartUI[0] && boolChartUI[0].instance && typeof boolChartUI[0].instance.series === 'function');
  }

  after_load() {
    try {
      const numberChartUI = this.$refs[ "numericChart" ] as any;
      if (!numberChartUI) {
        console.log('Chart ref not found');
        return;
      }
      
      if (!numberChartUI.instance) {
        console.log('Chart instance not found, waiting for initialization');
        // Retry after a short delay
        setTimeout(() => {
          this.after_load();
        }, 100);
        return;
      }
      
      if (typeof numberChartUI.instance.axes === 'function') {
        try {
          const axesResult = numberChartUI.instance.axes({ prefix: 'x' });
          if (axesResult && axesResult.items && axesResult.items.length > 0) {
            const numberChart = axesResult.items[0];
            if (numberChart && numberChart.range) {
              this.xAxis_scale_range = [ numberChart.range.min, numberChart.range.max ];
              setTimeout(() => {
                this.beforeZoomNumberChart(numberChart.range.min, numberChart.range.max);
              }, 200);
            } else {
              this.xAxis_scale_range = [];
            }
          } else {
            console.log('No axes items found');
            this.xAxis_scale_range = [];
          }
        } catch (axesError) {
          console.log('Error accessing chart axes:', axesError);
          this.xAxis_scale_range = [];
        }
      } else {
        console.log('Chart instance.axes is not a function, skipping axis setup');
        this.xAxis_scale_range = [];
      }
    } catch (error) {
      console.log('Error in after_load:', error);
      this.xAxis_scale_range = [];
    }
  }

  async doSearch(mode="click", existingParameters = [], existingOnOffParams = []) {
    this.$util.showLoading();
    console.log("loaded Chart ...");
    if (this.lodash.isEmpty(existingParameters) && this.lodash.isEmpty(existingOnOffParams)) {
      await this.fetchUnitData();
      await this.fetchVariablesData();
    }
    const valid = await this.observer.validate();
    if (!valid) {
      this.$util.goToErrorField(this.observer);
      return;
    }
    if (this.$route.query.treatmentNumber) {
      this.searchForm.treatmentId =
        this.$route.query.treatmentNumber.toString();
      this.$router.replace({ query: null });
    }

    this.$emit("onSearch", deepCopy(this.searchForm));
    let hasProDate = false;
    let dateStartQuery: any;
    let dateEndQuery: any;
    if (this.startDate && this.endDate) {
      hasProDate = true;
    }

    if (this.treatmentId) {
      this.searchForm.treatmentId = this.treatmentId;
    }
    if (
      !this.treatments.find(
        (treatment) => treatment.id == this.searchForm.treatmentId
      )
    ) {
      this.searchForm.treatmentId = "";
    }

    if (!this.searchForm.treatmentId) {
      this.searchForm.dateEnd = this.searchForm.dateEnd || moment().format("YYYY-MM-DD");
      this.searchForm.dateStart = this.searchForm.dateStart || moment().add(-3, "days").format("YYYY-MM-DD");
    }
    dateStartQuery = hasProDate
      ? this.startDate
      : !this.searchForm.dateStart
      ? ""
      : moment(this.searchForm.dateStart)
          .startOf("day")
          .utc()
          .format("YYYY-MM-DD HH:mm");
    dateEndQuery = hasProDate
      ? this.endDate
      : !this.searchForm.dateEnd
      ? ""
      : moment(this.searchForm.dateEnd).endOf("day").utc().format("YYYY-MM-DD HH:mm");


    if (this.VALID_SEARCH_FORM) {
      console.log('VALID_SEARCH_FORM');
      return;
    }
    try {
      this.calculateXAxisNumberChart();
      //this.$util.hideLoading();
      if (this.lodash.isEmpty(existingParameters) && this.lodash.isEmpty(existingOnOffParams)) {
        this.chartOptions.series = [];
        this.seriesRemoved = [];
      }
      if (mode === "click") {
        this.chartLoading = false;
        this.chartOptions.yAxis.scale.range = [0, this.maxValue || 100];
        this.searchForm.yMax = null;
        this.searchForm.yMin = null;
      }
      const seriesCopy = [];
      const colors = [];
      const numericParamPromise: Array<Promise<AxiosResponse<GetTreamentGraphResponse>>> = [];
      let  offset = 0;
      if (this.applyTimezone && this.selectedTimeZone){
        const now = new Date();
        const locationTime = now.toLocaleString("en-US", {timeZone: this.selectedTimeZone});
        const subdate = new Date(locationTime);
        offset = Math.round((subdate.getTime() - now.getTime())/1000);
      }
      if (this.lodash.isEmpty(existingOnOffParams)) {
        let NUMERIC_PARAMERTERS_FILTERED = [];
        if (this.lodash.isEmpty(existingParameters)) {
          NUMERIC_PARAMERTERS_FILTERED = this.NUMERIC_PARAMERTERS.filter(item => this.selectedNumericParam.includes(item.value));
        } else {
          NUMERIC_PARAMERTERS_FILTERED = this.NUMERIC_PARAMERTERS.filter(item => existingParameters.includes(item.value));
        }
        for (const selectedItem of NUMERIC_PARAMERTERS_FILTERED.map(
          (tmp) => tmp.value
        )) {
          numericParamPromise.push(this.getDataChart(
            selectedItem,
            dateStartQuery,
            dateEndQuery
          ));
        }

        Promise.all(numericParamPromise).then((responseArray) => {
          const totalSeries = [];
          const maxValue = [];
          responseArray.forEach((response) => {
            const treatmentGraphModel = response.data.data;
            treatmentGraphModel.data = treatmentGraphModel.data.map(d=> {return {...d, x: d.x? (d.x + offset): d.x};});
            const serie = this.calcNumeric(treatmentGraphModel);
            const maxValueOfY = Math.max(...serie.data.map(o => o.y), 0);
            maxValue.push(maxValueOfY);
            totalSeries.push(serie);
          });
          if (this.lodash.isEmpty(existingParameters)) this.maxValue = Math.max(...maxValue);
          else {
            this.maxValue = Math.max(...maxValue, this.maxValue - 10);
          }
          this.maxValue = Math.round(this.maxValue / 10) * 10 + 10;
          return Promise.resolve(totalSeries);
        }).then((totalSeries) => {
          this.chartOptions.yAxis.scale.range = [this.chartOptions.yAxis.scale.range[0], this.maxValue || 100];
          for (let i = 0; i < NUMERIC_PARAMERTERS_FILTERED.length; i++) {
            const param = NUMERIC_PARAMERTERS_FILTERED[i];
            const serie = totalSeries.find(value => value.name === param.value);
            if (param) colors.push(param.color);
            else colors.push(this.generateRandomColor());
            serie.nameBK = param.text;
            serie.variableId = param.value;
            seriesCopy.push(serie);
          }
          for (let i = 0; i < seriesCopy.length; i++) {
            this.chartOptions.series.push(
              {
                points: seriesCopy[i].data
                  .filter(p => typeof p.x === 'number' && !isNaN(p.x) && typeof p.y === 'number' && !isNaN(p.y))
                  .map(p => ({
                    x: p.x * 1000,
                    y: p.y
                  })),
                name: seriesCopy[i].nameBK,
                color: colors[i],
                variableId: seriesCopy[i].variableId
              }
            );
          }
        }).then(()=> {
          this.$util.hideLoading();
        });
      }

      if (this.lodash.isEmpty(existingParameters)) {
        // this.chartBoolLoading = false;
        const booleanParamPromise: Array<Promise<AxiosResponse<GetTreamentGraphResponse>>> = [];
        let OF_OFF_PARAMERTERS = [];
        if (this.lodash.isEmpty(existingOnOffParams)) {
          OF_OFF_PARAMERTERS = this.BOOL_PARAMERTERS.filter(item => this.selectedBoolParam.includes(item.value));
        } else {
          OF_OFF_PARAMERTERS = this.BOOL_PARAMERTERS.filter(item => existingOnOffParams.includes(item.value));
        }
        for (const selectedItem of OF_OFF_PARAMERTERS.map(
          (tmp) => tmp.value
        )) {
          const param = OF_OFF_PARAMERTERS.find(
              (val) => val.value === selectedItem
            );
          if (!this.seriesBool[selectedItem]){
            this.seriesBool[selectedItem] = this.getOptionBooleanChart([], param ? param.color : this.generateRandomColor(), selectedItem);
          }
 
          booleanParamPromise.push(this.getDataChart(
            selectedItem,
            dateStartQuery,
            dateEndQuery
          ));
        }
        
         await Promise.all(booleanParamPromise)
          .then((responseArray) => {
            responseArray.forEach((response) => {
              const series2 = [];
              const color2 = [];
              const treatmentGraphModel = response.data.data;
              treatmentGraphModel.data = treatmentGraphModel.data.map(d=> {return {...d, x: d.x? (d.x + offset): d.x};});
              const serie = this.calcBoolean(treatmentGraphModel);
              const param = OF_OFF_PARAMERTERS.find(
                (val) => val.value === serie.name
              );
              if (param) color2.push(param.color);
              else color2.push(this.generateRandomColor());
              series2.push(serie);
              const seriesmap = [
                {
                  line_width: 0.8,
                  points: serie.data.map((p) => {
                    return {
                      x: p.x * 1000,
                      y: p.y !== null ? p.y * 4 : p.y,
                    };
                  }),
                  name: serie.name,
                  color: param.color,
                },
              ];
              if (this.seriesBool[serie.name]) {
                this.seriesBool[serie.name].series = seriesmap;
              }
              
              // Safely update chart if it exists
              if (this.$refs[`boolchart-${serie.name}`] && this.$refs[`boolchart-${serie.name}`][0]) {
                try {
                  const chart = this.$refs[`boolchart-${serie.name}`][0] as any;
                  if (chart.instance && typeof chart.instance.series === 'function') {
                    const existingSeries = chart.instance.series(serie.name);
                    if (existingSeries) {
                      existingSeries.remove();
                    }
                    chart.instance.series.add(seriesmap[0]);
                  }
                } catch (chartError) {
                  console.log('Error updating boolean chart:', chartError);
                }
              }
            });
          }).then(() => {
          this.chartBoolLoading = true;
          this.$util.hideLoading();
          setTimeout(() => {
            this.hiddenLogoChart();
          }, 500);
        });
      }
      this.setYAxisRange(this.searchForm.yMin, this.searchForm.yMax);
    } catch (error) {
      this.$util.showError(error);
    } finally {
      setTimeout(() => {
        if (this.isChartReady()) {
          this.after_load();
        } else {
          setTimeout(() => {
            this.after_load();
          }, 500);
        }
        this.hiddenLogoChart();
      }, 1000);
    }
  }

  async doSearchMinMax() {
      this.setYAxisRange(this.searchForm.yMin, this.searchForm.yMax);
  }

  hiddenLogoChart() {
    const listLogoEle = document.querySelectorAll("[id=brandingLogo]");
    for (let i = 0; i < listLogoEle.length; i++) {
      listLogoEle[i].setAttribute('display', 'None');
    }
  }

  getDataChart(
    variableId: string,
    dateStartQuery: string,
    dateEndQuery: string
  ):  Promise<AxiosResponse<GetTreamentGraphResponse>> {
    return new TreatmentMonitoringApi().getTreatmentGraph({
      variableId: variableId,
      unitId: this.unitId,
      treatmentId: this.searchForm.treatmentId,
      startDate: dateStartQuery,
      endDate: dateEndQuery,
    });
    // return rs.data.data;
  }

  calcNumeric(value: TreatmentGraphModel) {
    const selectedItem = value.variableId;
    const serie = {
      name: selectedItem,
      nameBK: selectedItem,
      data: [],
    };
    let data_sort = this.lodash.sortBy(value.data, (val) => val.x);
    data_sort = this.removeSameValue(data_sort);
    let data_x_start, data_x_end;
    let data_serie = [...data_sort];
    if (!this.searchForm.dateStart && !this.lodash.isEmpty(data_serie)) {
      data_x_start = moment
        .unix(data_serie[0].x)
        .subtract(this.X_HOUR, "hours")
        .unix();
      data_serie = [{ x: data_x_start, y: null }, ...data_serie];
    }
    if (!this.searchForm.dateEnd && !this.lodash.isEmpty(data_serie)) {
      data_x_end = moment
        .unix(data_serie[data_serie.length - 1].x)
        .add(this.X_HOUR, "hours")
        .unix();
      data_serie = [...data_serie, { x: data_x_end, y: null }];
    }
    if (this.searchForm.dateEnd && !this.lodash.isEmpty(data_serie)) {
      if (new Date(this.searchForm.dateEnd) > new Date()) {
        data_x_end = moment
        .unix(data_serie[data_serie.length - 1].x)
        .add(this.X_HOUR, "hours")
        .unix();
        data_serie = [...data_serie, { x: data_x_end, y: null }];
      }
    }
    serie.data = data_serie;
    return serie;
  }

  removeSameValue(dataSort) {
    const REMOVE_LIMIT = 100;
    const dataSortNew = [];
    if (this.lodash.isEmpty(dataSort)) {
      return dataSortNew;
    }
    dataSortNew.push(dataSort[0]);
    let removed = 0;
    for (let i = 1; i < dataSort.length; i++) {
      const previousEle = dataSort[i-1];
      const currentEle = dataSort[i];
      const nextEle = dataSort[i+1];
      if (
        !nextEle
        || ((currentEle && previousEle && currentEle.y !== previousEle.y) || (currentEle && nextEle && currentEle.y !== nextEle.y))
        || (removed >= REMOVE_LIMIT)) {
        dataSortNew.push(currentEle);
        removed = 0;
      } else {
        removed++;
      }
    }
    return dataSortNew;
  }

  calcBoolean(value: TreatmentGraphModel) {
    const selectedItem = value.variableId;
    const serie = {
      name: selectedItem,
      data: [],
    };
    let data_sort = this.lodash.sortBy(value.data, (val) => val.x);
    data_sort = this.removeSameValue(data_sort);
    let data_x_start, data_x_end;
    let data_serie = [...data_sort];
    if (!this.searchForm.dateStart && !this.lodash.isEmpty(data_serie)) {
      data_x_start = moment
        .unix(data_serie[0].x)
        .subtract(this.X_HOUR, "hours")
        .unix();
      data_serie = [{ x: data_x_start, y: null }, ...data_serie];
    }
    if (!this.searchForm.dateEnd && !this.lodash.isEmpty(data_serie)) {
      data_x_end = moment
        .unix(data_serie[data_serie.length - 1].x)
        .add(this.X_HOUR, "hours")
        .unix();
      data_serie = [...data_serie, { x: data_x_end, y: null }];
    }
    if (this.searchForm.dateEnd && !this.lodash.isEmpty(data_serie)) {
      if (new Date(this.searchForm.dateEnd) > new Date()) {
        data_x_end = moment
        .unix(data_serie[data_serie.length - 1].x)
        .add(this.X_HOUR, "hours")
        .unix();
        data_serie = [...data_serie, { x: data_x_end, y: null }];
      }
    }
    serie.data = data_serie.map((point) => {
      if (point.y === null) {
        point.y = null;
      } else if (point.y === 1) {
        point.y = 1;
      } else {
        point.y = 0;
      }
      return point;
    });
    return serie;
  }

  onSelectedNumericParamWatch(val: string[]) {
    let backup = localStorage.getItem("treatmentMonitoringDetailNumber");
    if (!backup){
      const data ={};
      data[this.selectedUnit.id] = val;
      localStorage.setItem("treatmentMonitoringDetailNumber", JSON.stringify(data));
    } else{
      const data = JSON.parse(backup);
      data[this.selectedUnit.id] = val;
      localStorage.setItem("treatmentMonitoringDetailNumber", JSON.stringify(data));
    }
    this.$util.showLoading();
    setTimeout(() => {
      const a = this.lodash.reject(this.NUMERIC_PARAMERTERS, (p) =>
        val.includes(p.value)
      );
      for (const item of a) {
        const index = this.chartOptions.series.findIndex((s) => s.variableId === item.value);
        if (index !== -1) {
          this.seriesRemoved.push(...this.chartOptions.series.splice(index, 1));
        }
      }
      for (const item of val) {
        const index = this.seriesRemoved.findIndex((s) => s.variableId === item);
        if (index !== -1)
           this.chartOptions.series.push(...this.seriesRemoved.splice(index, 1));
      }
      const idSelected = this.chartOptions.series.map(item => {
        return item.variableId;
      });
      const selectFiltered = val.filter(item => !idSelected.includes(item) && this.seriesRemoved.findIndex((s) => s.variableId === item) === -1);
      if (!this.lodash.isEmpty(selectFiltered)) this.doSearch("click", selectFiltered);
      else this.$util.hideLoading();
    }, 100);
  }

  onSelectedBoolParamWatch(val: string[]) {
    let backup = localStorage.getItem("treatmentMonitoringDetailBool");
    if (!backup){
      const data ={};
      data[this.selectedUnit.id] = val;
      localStorage.setItem("treatmentMonitoringDetailBool", JSON.stringify(data));
    } else{
      const data = JSON.parse(backup);
      data[this.selectedUnit.id] = val;
      localStorage.setItem("treatmentMonitoringDetailBool", JSON.stringify(data));
    }
    this.$util.showLoading();
    setTimeout(() => {
      const a = this.lodash.reject(this.BOOL_PARAMERTERS, (p) =>
        val.includes(p.value)
      );
      const idHadData = Object.keys(this.seriesBool);
      const boolParamNeedGetData = val.filter(item => !idHadData.includes(item));
      if (!this.lodash.isEmpty(boolParamNeedGetData)) this.doSearch("click", [], boolParamNeedGetData);
      else this.$util.hideLoading();
      this.hiddenLogoChart();
    }, 100);
  }

  beforeZoomNumberChart(min: number, max: number) {
    for (const item of this.selectedBoolParam) {
      if (this.$refs[`boolchart-${item}`]){
      const chart = (this.$refs[`boolchart-${item}`][0] as any);
      if (chart && chart.instance &&chart.instance.axes({prefix:'x'}).items){
        const xAxis = chart.instance.axes({prefix:'x'}).items[0];
        xAxis.options({ scale_range: [min, max] });
      }
      }
    }
  }

  reactiveWithNumberChart(backToOrigin: boolean) {
    for (const item of this.selectedBoolParam) {
      const booleanChartBox = document.getElementById(`boolean-chart-box-${item}`);
      booleanChartBox.style.marginLeft = backToOrigin && this.maxValue >= 100 ? '45px' : '40px';
    }
  }
}
